// /pages/StartPage.tsx
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import Button from '../components/common/Button';
import useScrollToTop from '../hooks/hook';
import { useNavigate } from 'react-router-dom';

const ThanksPage: React.FC = () => {
  useScrollToTop();

  const navigate = useNavigate();
  const handleContactClick = () => {
    navigate(`/survey`);
  };

  return (
    <div className="l_container l_start_page">
      <Header />
      <p className="start_page_desc">
        挑戦を続けるための行動と心の状態について<br />科学的根拠に基づき診断します
      </p>
      <div className="start_page_button">
        <Button onClick={handleContactClick} className="" iconType="right" iconSize={30}>
          お試し版を始める
        </Button>
        <p className="start_page_desc_sub">日頃感じているまま、直感的に回答してください。</p>
        <p className="start_page_desc_sub">※所要時間は５−１０分です。</p>
      </div>
      <Footer />
    </div>

  );
};

export default ThanksPage;